// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"export"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M10 3H3V21H21V15","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M10.5 14.75L10.5 11.5C10.5 8.73857 12.7386 6.5 15.5 6.5L21 6.49999M19 10L22.5 6.49999L19 3","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ExportIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'export',
    ref,
    icon: element,
  },
));

ExportIcon.displayName = 'ExportIcon';

export default ExportIcon;
